import React from "react";
import SectionHeader from "../components/SectionHeader";
import Joinvillage from "../components/landingpage/Joinvillage";
import { Link } from "react-router-dom";

const partners = [
  { name: "SOV", logo: "/images/partnerships/SOV.jpg", url: "https://www.specialolympics.com.au/" },
  { name: "Atalgo", logo: "/images/partnerships/atalgo.jpg", url: null },
  { name: "Best Chance", logo: "/images/partnerships/bestchance.jpg", url: "https://www.bestchance.org.au/" },
  { name: "Carevo", logo: "/images/partnerships/carevo.jpg", url: "https://carevo.com.au/" },
  { name: "Envaedha", logo: "/images/partnerships/envaedha.jpg", url: "https://envaedha.com.au" },
  { name: "Flourish", logo: "/images/partnerships/Flourish.jpg", url: "https://www.flourishaustralia.org.au/" },
  { name: "Social Threads", logo: "/images/partnerships/social-threads.jpg", url: "https://www.socialthreads.au/" },
  { name: "Soulful Learning", logo: "/images/partnerships/soulful-learning.jpg", url: "https://soulful-learning.com.au/" },
];

const PartnershipsPage = () => {
  return (
    <div className="w-full flex flex-col items-center gap-[56px] md:gap-[100px]">
      {/* Hero */}
      <div
        className="w-full flex flex-col items-center justify-center px-6 md:px-16 py-16 md:py-24 text-center"
        style={{
          background: "linear-gradient(135deg, #EBF2FF 0%, #F5F8FF 100%)",
        }}
      >
        <div className="max-w-[720px] flex flex-col items-center gap-5">
          <span className="text-[13px] md:text-[14px] font-[600] text-[#1167D0] tracking-widest uppercase">
            Our Partners
          </span>
          <h1 className="text-[32px] md:text-[52px] text-[#0D121F] font-[800] font-avenir leading-tight">
            Building a Better Future, Together
          </h1>
          <p className="text-[15px] md:text-[17px] text-[#6B7280] leading-relaxed max-w-[560px]">
            We are proud to collaborate with organisations who share our passion
            for supporting neurodivergent individuals and their families across
            Australia.
          </p>
        </div>
      </div>

      {/* Partners grid */}
      <div className="w-full px-6 md:px-16">
        <div className="max-w-[1280px] mx-auto flex flex-col gap-12">
          <SectionHeader
            title="Trusted Partners"
            description="Organisations we proudly work with"
            para="Each of our partners brings unique expertise and a shared commitment to creating a more inclusive world for the neurodivergent community."
          />

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
            {partners.map((partner) => {
              const card = (
                <div
                  className={`flex flex-col items-center justify-center gap-3 bg-white rounded-[20px] p-6 border border-[#EEF0F6] transition-shadow duration-300 ${partner.url ? "hover:shadow-lg cursor-pointer" : ""}`}
                  style={{ boxShadow: "0px 2px 12px rgba(0,0,0,0.06)" }}
                >
                  <div className="w-full h-[100px] flex items-center justify-center">
                    <img
                      src={process.env.PUBLIC_URL + partner.logo}
                      alt={partner.name}
                      className="max-h-[80px] max-w-full object-contain"
                    />
                  </div>
                  <p className="text-[13px] font-[600] text-[#6B7280] text-center">
                    {partner.name}
                  </p>
                </div>
              );
              return partner.url ? (
                <a key={partner.name} href={partner.url} target="_blank" rel="noopener noreferrer">
                  {card}
                </a>
              ) : (
                <div key={partner.name}>{card}</div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Become a partner CTA */}
      <div className="w-full px-6 md:px-16">
        <div className="max-w-[1280px] mx-auto">
          <div
            className="flex flex-col md:flex-row items-center justify-between gap-8 rounded-[24px] px-8 md:px-16 py-12 border border-[#EEF0F6]"
            style={{ background: "#F7F9FF" }}
          >
            <div className="flex flex-col gap-3 text-center md:text-left">
              <h2 className="text-[24px] md:text-[32px] text-[#0D121F] font-[800] font-avenir leading-tight">
                Interested in partnering with us?
              </h2>
              <p className="text-[15px] text-[#6B7280] max-w-[480px]">
                We're always looking to grow our network of like-minded
                organisations. Reach out and let's explore how we can work
                together.
              </p>
            </div>
            <Link
              to="/contactus"
              className="whitespace-nowrap py-[14px] px-8 bg-[#1167D0] text-white text-[15px] font-[700] rounded-[32px] hover:bg-[#0d52a8] transition-colors"
            >
              Get in Touch →
            </Link>
          </div>
        </div>
      </div>

      <Joinvillage />
    </div>
  );
};

export default PartnershipsPage;
